/**
 * TanStack Query hooks for `cordova-ionic-sdk`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	cordovaIonicSdkQueryKeys,
	ingestEvent,
	listInstalls,
	registerInstall,
	type IngestEventBody,
	type IngestEventResponse,
	type ListInstallsResponse,
	type RegisterInstallBody,
	type RegisterInstallResponse,
} from "./api";

export function useCordovaIonicSdkList(): UseQueryResult<ListInstallsResponse, Error> {
	return useQuery({
		queryKey: cordovaIonicSdkQueryKeys.list(),
		queryFn: listInstalls,
	});
}

export function useCordovaIonicSdkRegister(): UseMutationResult<
	RegisterInstallResponse,
	Error,
	RegisterInstallBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: registerInstall,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: cordovaIonicSdkQueryKeys.all });
		},
	});
}

export function useCordovaIonicSdkEvent(): UseMutationResult<
	IngestEventResponse,
	Error,
	IngestEventBody
> {
	return useMutation({
		mutationFn: ingestEvent,
	});
}
